module.exports = __webpack_public_path__ + "static/empty-state-bg-5e2e0e86bdc23bc554ba8966d1e2ea46.svg";